module.exports = __webpack_public_path__ + "static/media/BH.c47c4db1.svg";